const messages = {
  bonus: {
    title: "Bónuszjóváírások áttekintése",
    description: "Az euróban számolt bónuszokat a résztvevő vállalatok a beküldött értékesítési adatok alapján kapják.",
    lastMonth: "Előző hónap",
    currentMonth: "Aktuális hónap",
    totalCurrentYear: "Aktuális év összesen",
    totalLastYear: "Előző év összesen",
  },
  points: {
    title: "Pontjóváírások áttekintése",
    period: "Folyó naptári év ({year})",
    totalAwarded: "Összes jóváírt pont",
    redeemed: "Beváltott pontok",
    totalBalance: "Összes pontegyenleg",
    redemptionRate: "Beváltott pontok a jóváírt pontok százalékában",
    averageAwarded: "Átlagosan jóváírt pontok megvásárolt gumiabroncsonként",
    standardAwarded: "Nettó pontok a kiszámított értékesítési sorokból, visszáruval együtt",
    bsPlusInclBooster: "Pontok a pozitív mennyiségű értékesítési sorokból",
    perTire: "Beváltott pontok megvásárolt gumiabroncsonként",
  },
  tires: {
    title: "Gumiabroncs mennyiség áttekintése",
    description: "Az ügyfelek által vásárolt gumiabroncsok",
    prevMonth: "Előző hónap",
    totalLastYear: "Előző év összesen",
    purchaseIndirect: "Vásárlás nagykereskedőn keresztül (közvetett)",
    purchaseDirect: "Vásárlás nagykereskedőn keresztül (közvetlen)",
    totalCurrentYear: "Aktuális év összesen",
    currentMonth: "Aktuális hónap",
  },
  participating: {
    title: "Részt vevő ügyfelek áttekintése",
    description: "A BRIDGESTONE PLUS rendszerben regisztráló vállalatok ügyfélszám alapján rendelhetők hozzánk.",
    total: "Összesen",
    newThisMonth: "Új ebben a hónapban",
    newThisYear: "Új ebben az évben",
    createdInCurrentMonth: "Az aktuális hónapban létrehozva (admin által)",
    loginsCurrentYear: "Bejelentkezések az aktuális évben (a feltételek elfogadása után)",
  },
  brand: {
    title: "Márka",
    description: "Vásárlásai részletesen",
    centerTitle: "Márka\nszerint",
  },
  rim: {
    title: "Felni",
    centerTitle: "Felni méret\nszerint",
  },
  tireGoals: {
    title: "Gumi célok",
    subtitle: "Szerezzen pontokat gumiabroncs vásárlásaiért.",
    centerTitle: "Gumiméret\nszerint",
    tiresRemaining: "Hátralévő gumik",
    progressionTarget: "Haladási cél: ",
    pointsEarnedPurchases: "a vásárlásokkal\n" + "szerzett\n" + "pontok",
    pointsEarnedBoosters: "a boosterekkel\n" + "szerzett\n" + "pontok",
    purchasesDetail: "Vásárlásai részletesen",
    cta: "Tudjon meg többet pontjairól",
    pointsTitle: "Az Ön pontjai",
    pointsSubtitle: "A Bridgestone vásárlásokkal szerzett pontok",
    achievementsTitle: "Az Ön eredményei",
    achievementsSubtitle: "Az Ön éves vállalása:",
    achievementsSubtitle2: "gumi",
  },
  score: {
    title: "Pontszám",
    total: "Összesen",
    credits: "Jóváírások",
    deductions: "Levonások",
        unlockedPoints: "Feloldott pontok",
        pendingPoints: "Függő pontok",
  },
  score_extended: {
    title1: "Pont egyenleg",
    title2: "Bónusz euróban",
    balance: "Pont egyenleg",
    bonus_in_euro: "Bónusz euróban",
    date: "Dátum",
    added_points: "Hozzáadott pontok",
    total_bands: "Összes márka",
    goal: "Cél",
    tyres_previous_year: "Előző évben eladott gumik",
    tyres_current_year: "Idén eladott gumik",
    target_this_year: "Idei értékesítési cél",
    bonus_this_year: "Megkeresett bónusz (€)",
    loyal_minimum: "Minimális hűségszint",
    bonus_multiplier: "Bónusz szorzó mértéke",
  },
  lastImport: {
    label: "Értékesítési adatok utolsó importja:",
    on: "",
  },
  wholesalerTable: {
    title: "Részt vevő ügyfelek részletesen",
    description: "Az alábbiakban azok a vállalatok találhatók, amelyek az Ön cégének ügyfélszámával regisztráltak a BRIDGESTONE PLUS rendszerben. A szűrőkkel rendezhet, illetve a keresővel ügyfeleket találhat.",
    columns: {
      customer_number: "Ügyfélszám",
      address_company_name: "Vállalat",
      address_street: "Utca és házszám",
      address_postal_code: "Irányítószám",
      address_city: "Város",
      last_registration: "Utolsó regisztráció",
      network: "Hálózat",
      profile_group: "Csoport",
      tires_amount: "Gumik mennyisége",
      point_balance: "Pont egyenleg",
      bonus: "Bónusz",
      details: "Részletek",
    },
    searchPlaceholder: "Keresés",
  },
  dealerTable: {
    columns: {
      date: "Dátum",
      wholesaler_bs_plus: "Nagykereskedő BS+",
      customer_number: "Ügyfélszám",
      article: "Cikk",
      brand: "Márka",
      product: "Termék",
      type: "Típus",
      inch: "Coll",
      season: "Szezon",
      amount: "Mennyiség",
      points: "Pontok",
      activity: "Aktivitás",
      total_points: "Összes pont",
    },
    title: "Kereskedői tábla",
    description: "A kereskedői aktivitások áttekintése",
  },
  business_units: {
    title: "Üzleti egységek",
    centerTitle: "Egység\nszerint",
  },
  season: {
    title: "Szezon",
    centerTitle: "Évszak\nszerint",
  },
};

export default {
  messages,
};
